var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBogoOutline(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34196 3.23633C9.86768 3.23633 10.3717 3.44352 10.7428 3.81462L16.1855 9.25732C16.9587 10.0304 16.9587 11.2829 16.1855 12.056L12.0571 16.1844C11.284 16.9575 10.0316 16.9575 9.25846 16.1844L3.81576 10.7417C3.44157 10.3706 3.23438 9.86963 3.23438 9.34391V4.7207C3.23438 3.9012 3.89925 3.23633 4.71875 3.23633H9.34196ZM4.71875 9.34391C4.71875 9.47379 4.77132 9.60058 4.8641 9.69336L10.3068 15.1361C10.4985 15.3278 10.814 15.3278 11.0057 15.1361L15.1341 11.0076C15.3258 10.8159 15.3258 10.5005 15.1341 10.3088L9.69141 4.86605C9.59863 4.77327 9.47184 4.7207 9.34196 4.7207H4.71875V9.34391ZM6.69792 5.71029C6.96037 5.71029 7.21207 5.81455 7.39766 6.00013C7.58324 6.18571 7.6875 6.43742 7.6875 6.69987C7.6875 6.96232 7.58324 7.21403 7.39766 7.39961C7.21207 7.58519 6.96037 7.68945 6.69792 7.68945C6.43546 7.68945 6.18376 7.58519 5.99818 7.39961C5.81259 7.21403 5.70833 6.96232 5.70833 6.69987C5.70833 6.43742 5.81259 6.18571 5.99818 6.00013C6.18376 5.81455 6.43546 5.71029 6.69792 5.71029Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBogoOutline);
export default __webpack_public_path__ + "static/media/bogo-outline.d33284625bedc84b0add685c954b7b42.svg";
export { ForwardRef as ReactComponent };